import { MprcFilterLine } from "components/filter";
import { MprcButtonDropdownChecked } from "components/MprcButtonDropdownChecked";
import { KnowledgeSearchOption, PublicationClassificationType, PublicationType } from "generated/CoreApi_v1";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ChooseKnowledgePeriod } from "views/general/GlobalSearch/components/ChooseKnowledgePeriod";
import { ChooseKnowledgeRestrictionComponent } from "views/general/GlobalSearch/components/ChooseKnowledgeRestrictionComponent";
import { GlobalSearchOrderByComponent } from "views/general/GlobalSearch/components/GlobalSearchOrderByComponent";
import { KnowledgeSearchComponent } from "views/general/GlobalSearch/components/KnowledgeSearchComponent";
import { useGlobalSearch } from "views/general/GlobalSearch/GlobalSearchProvider";

/////////////////////////////////////////////////////////////////////////////////////////////////

export const FullKnowledgeSearch = () => {
    const { t } = useTranslation("shared");

    const {
        searchResult,
        orderBy, setOrderBy,
        kFilters: filters, setKnowledgeFilters: setFilters
    } = useGlobalSearch();

    ///
    const renderFilter = useCallback(() => {
        return (
            <MprcFilterLine>
                <div>
                    <MprcButtonDropdownChecked
                        title={t("GlobalSearch.Filters.Knowledge.PublicationTypeOption")}
                        selected={filters.publicationType}
                        onChange={(selected) => setFilters({ publicationType: selected })}
                        items={
                            [
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Any"), value: null },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Post"), value: PublicationType.Post },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Binder"), value: PublicationType.Binder },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Question"), value: PublicationType.Question },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.List"), value: PublicationType.List },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Poll"), value: PublicationType.Poll }
                            ]
                        }
                    />

                    <MprcButtonDropdownChecked
                        title={t("GlobalSearch.Filters.Knowledge.ClassificationTypeOption")}
                        selected={filters.classificationType}
                        onChange={(selected) => setFilters({ classificationType: selected })}
                        items={
                            [
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationClassificationType.Any"), value: null },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationClassificationType.Video"), value: PublicationClassificationType.Video },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationClassificationType.Audio"), value: PublicationClassificationType.Audio },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationClassificationType.Image"), value: PublicationClassificationType.Image },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationClassificationType.Document"), value: PublicationClassificationType.Document }
                            ]
                        }
                    />

                    <ChooseKnowledgePeriod
                        selectedOption={filters.period}
                        customStartDate={filters.periodStart}
                        customEndDate={filters.periodEnd}
                        onChange={
                            (selected, customStart, customEnd) => {
                                setFilters({ period: selected, periodStart: customStart, periodEnd: customEnd });
                            }
                        }
                    />

                    <ChooseKnowledgeRestrictionComponent
                        selectedOption={filters.restriction}
                        onChange={(selected) => setFilters({ restriction: selected })}
                    />

                </div>

                <GlobalSearchOrderByComponent
                    selectedOption={orderBy}
                    onChange={(orderBy) => setOrderBy(orderBy)}
                />

            </MprcFilterLine>
        );
    }, [filters, orderBy]);

    /////////////////////////////////////////////////////////////////////////////////////////////////

    ///
    return (
        <KnowledgeSearchComponent
            filters={filters}
            searchOption={KnowledgeSearchOption.All}
            showTitle={false}
            initialData={searchResult?.knowledgeSearch}
            renderFilter={renderFilter()}
            filterEmptyTextKey="shared:GlobalSearch.FullSearch.NoPublicationsFound"
            filterCountTextKey="shared:GlobalSearch.FullSearch.PublicationsFound"
        />
    );
};
